export class RepairLog {
    logUID?: string;
    repairUID!: string;
    date: Date = new Date();
    action!: string;
    notes?: string;
    userUID?: string;
    userName?: string;
    documentUIDs?: string[]; // Associated document IDs

    constructor(repairUID: string, action: string, notes?: string) {
        this.repairUID = repairUID;
        this.action = action;
        this.notes = notes;
    }
} 